import React, { useState } from 'react';
import { MicIcon, HeadphonesIcon, SparklesIcon, XIcon, MenuIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import NewsletterSection from './NewsletterSection';
import CompaniesSection from './CompaniesSection';
import Footer from './Footer';
import { HyperText } from './HyperText';
const HeroSection = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <>
      <div className="w-full relative" data-id="element-27">
        <div className="absolute inset-0 w-full h-full overflow-hidden" data-id="element-28">
          <div className="absolute inset-0 bg-black bg-opacity-70 z-10" data-id="element-29"></div>
          <iframe src="https://player.vimeo.com/video/1066379860?badge=0&autopause=0&player_id=0&app_id=58479&background=1&autoplay=1&loop=1&muted=1" className="absolute w-[400%] sm:w-[200%] md:w-full h-full -left-[150%] sm:-left-[50%] md:left-0 top-0 object-cover scale-100 md:scale-[1.5]" allow="autoplay; fullscreen; picture-in-picture" style={{
          pointerEvents: 'none'
        }} data-id="element-30"></iframe>
        </div>
        <header className="relative z-50 w-full px-4 py-4 sm:py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-31">
          <div className="flex items-center" data-id="element-32">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rUYX92r9ankPSBEUVq4dcY/dfswhite.png" alt="DealFlow Logo" className="h-16 sm:h-20 md:h-24 ml-2 sm:ml-4" data-id="element-33" />
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-34">
            <a href="https://guestlist.dealflowshow.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-35">
              Episodes
            </a>
            <a href="https://link.getdealflow.ai/widget/survey/b6PKmAFLQgN8WFjwoUsI?notrack=true" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-36">
              Become a Guest
            </a>
            <a href="https://the-deal-flow-show-media-4tyalnp.gamma.site/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors" data-id="element-37">
              Media Kit
            </a>
          </nav>
          <button className="md:hidden relative z-50 p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-38">
            {isMobileMenuOpen ? <XIcon className="h-8 w-8" data-id="element-39" /> : <MenuIcon className="h-8 w-8" data-id="element-40" />}
          </button>
        </header>
        <div className={`fixed inset-0 bg-black/80 z-40 md:hidden transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-41" />
        <div className={`fixed top-0 right-0 w-[280px] h-full bg-gray-900/95 backdrop-blur-sm z-40 transform transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-42">
          <div className="flex flex-col p-6 pt-20" data-id="element-43">
            <nav className="flex flex-col space-y-4" data-id="element-44">
              <a href="https://guestlist.dealflowshow.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white hover:bg-gray-800 transition-colors px-4 py-3 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-45">
                Episodes
              </a>
              <a href="https://link.getdealflow.ai/widget/survey/b6PKmAFLQgN8WFjwoUsI?notrack=true" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white hover:bg-gray-800 transition-colors px-4 py-3 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-46">
                Become a Guest
              </a>
              <a href="https://the-deal-flow-show-media-4tyalnp.gamma.site/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white hover:bg-gray-800 transition-colors px-4 py-3 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-47">
                Media Kit
              </a>
            </nav>
          </div>
        </div>
        <div className="relative z-20" data-id="element-48">
          <div className="max-w-7xl mx-auto px-4 pt-4 pb-12 sm:pb-20" data-id="element-49">
            <div className="text-center max-w-4xl mx-auto" data-id="element-50">
              <div className="inline-flex items-center px-2 sm:px-3 py-1 rounded-full bg-gray-800/50 mb-4 sm:mb-6" data-id="element-51">
                <span className="flex h-2 w-2 rounded-full bg-custom-green mr-2 animate-pulse" data-id="element-52"></span>
                <span className="text-xs sm:text-sm text-white" data-id="element-53">
                  New episodes weekly
                </span>
              </div>
              <div className="flex justify-center px-2 sm:px-4" data-id="element-54">
                <HyperText text="THE DEAL FLOW SHOW" className="text-6xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-4 sm:mb-6 text-white" duration={1000} framerProps={{
                initial: {
                  opacity: 0,
                  y: -20
                },
                animate: {
                  opacity: 1,
                  y: 0
                },
                exit: {
                  opacity: 0,
                  y: 10
                }
              }} data-id="element-55" />
              </div>
              <p className="text-base sm:text-lg md:text-xl text-white mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-2 sm:px-0" data-id="element-56">
                Every week, we have what feels like a conversation at dinner
                with the top dealmakers in the world—not just another corporate
                interview. Our goal is to uncover incredible wisdom and have top
                dealmakers tell the stories you won't hear anywhere else.
              </p>
              <div className="flex justify-center mb-8 sm:mb-12" data-id="element-57">
                <a href="https://www.youtube.com/channel/UCyGQoszwrp0yDvxu2GSqhEQ" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-custom-green hover:bg-custom-green/90 text-black font-medium rounded-lg transition-all transform hover:scale-105 mx-4 sm:mx-0" data-id="element-58">
                  Watch Now
                </a>
              </div>
              <div className="mb-8 sm:mb-12" data-id="element-59">
                <p className="text-white mb-3 font-medium text-sm sm:text-base" data-id="element-60">
                  Available on:
                </p>
                <div className="flex flex-wrap justify-center gap-4 sm:gap-6 px-2" data-id="element-61">
                  <a href="https://open.spotify.com/show/3hEyUCgY0XHlbqm4huUqPx" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-62">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hnTR4tf2pRtwPm41ZpXU9R/Spotify_logo_without_text.svg.png" alt="Spotify" className="h-6 sm:h-8" data-id="element-63" />
                  </a>
                  <a href="https://www.youtube.com/@TheDealFlowShow" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-64">
                    <img src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png" alt="YouTube" className="h-6 sm:h-8" data-id="element-65" />
                  </a>
                  <a href="https://www.linkedin.com/in/ivan-acuna-841827198/" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-66">
                    <img src="https://cdn-icons-png.flaticon.com/512/3536/3536505.png" alt="LinkedIn" className="h-6 sm:h-8" data-id="element-67" />
                  </a>
                  <a href="https://podcasts.apple.com/us/podcast/the-deal-flow-show/id1812558209" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-68">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/knNThPwHLVK59cpwHkVHfV/applepod.png" alt="Apple Podcasts" className="h-6 sm:h-8" data-id="element-69" />
                  </a>
                  <a href="https://music.amazon.com/podcasts/191df134-af6c-439b-98dd-17725a9e2189/the-deal-flow-show" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-70">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jCRXi7XUqPdb9R3ARbmwCY/amzn.png" alt="Amazon Music" className="h-6 sm:h-8 w-8 object-contain my-auto" data-id="element-71" />
                  </a>
                  <a href="https://www.iheart.com/podcast/269-the-deal-flow-show-274150533/" target="_blank" rel="noopener noreferrer" className="opacity-70 hover:opacity-100 transition-opacity" data-id="element-72">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3r2zXvCLzhqJQceU2ApJ1i/ihrt.png" alt="iHeart Radio" className="h-6 sm:h-8" data-id="element-73" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsletterSection data-id="element-74" />
      <CompaniesSection data-id="element-75" />
      <Footer data-id="element-76" />
    </>;
};
export default HeroSection;